export const formatTime = (seconds: number | null) => {
  if (seconds === null) return 'N/A';
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${mins}:${secs.toString().padStart(2, '0')}`;
};

// Error tracking with cooldown to avoid spam
const errorCooldowns = new Map<string, number>();
const ERROR_COOLDOWN_MS = 5000; // 5 seconds

export const trackError = (message: string, contentId?: string) => {
  // Create a key from the message to dedupe similar errors
  const key = `${message}:${contentId || ''}`;
  const now = Date.now();
  const lastSent = errorCooldowns.get(key);

  if (lastSent && now - lastSent < ERROR_COOLDOWN_MS) {
    return; // Skip - sent recently
  }

  errorCooldowns.set(key, now);

  fetch('/api/events/error', {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ message, contentId }),
  }).catch(() => {
    // Silently fail - don't cause more errors
  });
};
